import { Component } from '@angular/core';

@Component({
  selector: 'app-user-not-found',
  imports: [],
  templateUrl: './user-not-found.html',
  styleUrl: './user-not-found.scss',
})
export class UserNotFound {}
